import { get, post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'


export const findTaskDefinitionListRequest = () => ({
    type: type.FIND_TASK_DEFINITION_LIST_REQUEST,
})


export const findTaskDefinitionListSuccess = (taskDefinitionList) => ({
    type: type.FIND_TASK_DEFINITION_LIST_SUCCESS,
    payload: {
        taskDefinitionList,
    },
})

export const findTaskDefinitionListError = (error) => ({
    type: type.FIND_TASK_DEFINITION_LIST_ERROR,
    payload: {
        error,
    },
})


export const findTaskDefinitionList = () => (dispatch, getState) => {
    dispatch(findTaskDefinitionListRequest())

    get('/api/process/task-definition/find-all')
        .then(taskDefinitionList => {
            dispatch(findTaskDefinitionListSuccess(taskDefinitionList))
        })
        .catch(error => {
            dispatch(findTaskDefinitionListError(error))
        })
}


export const changeTaskDefinition = (taskDefinitionId, name, value) => ({
    type: type.CHANGE_TASK_DEFINITION,
    payload: {
        taskDefinitionId,
        name,
        value,
    },
})


export const saveTaskDefinitionRequest = () => ({
    type: type.SAVE_TASK_DEFINITION_REQUEST,
})

export const saveTaskDefinitionSuccess = (stateResponsible) => ({
    type: type.SAVE_TASK_DEFINITION_SUCCESS,
    payload: {
        stateResponsible,
    },
})

export const saveTaskDefinitionError = (error) => ({
    type: type.SAVE_TASK_DEFINITION_ERROR,
    payload: {
        error,
    },
})

export const saveTaskDefinition = (taskDefinitionId) => (dispatch, getState) => {
    const state = getState()
    const taskDefinition = selector.selectTaskDefinitionById(state, taskDefinitionId)
    if (!taskDefinition) {
        return
    }

    dispatch(saveTaskDefinitionRequest())

    post('/api/process/task-definition/save', taskDefinition)
        .then(taskDefinition => {
            dispatch(saveTaskDefinitionSuccess(taskDefinition))
        })
        .catch(error => {
            dispatch(saveTaskDefinitionError(error))
        })
}




// WEBPACK FOOTER //
// ./src/modules/process/state/task-definition/action.js